/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraMisConfigurationsTrendSummary {
    getFixupPrototypeFunction() { return InfraMisConfigurationsTrendSummary.fixupPrototype; }

    static newInstance(model: Partial<InfraMisConfigurationsTrendSummary>): InfraMisConfigurationsTrendSummary {
        let obj = Object.assign(new InfraMisConfigurationsTrendSummary(), model);
        InfraMisConfigurationsTrendSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraMisConfigurationsTrendSummary>): InfraMisConfigurationsTrendSummary {
        if (!model) return null;
        return InfraMisConfigurationsTrendSummary.newInstance(<InfraMisConfigurationsTrendSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraMisConfigurationsTrendSummary) {
        if (!obj) return;

        models.InfraMisConfigurationsTrendSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraMisConfigurationsTrendSummary): boolean {
        Object.setPrototypeOf(obj, InfraMisConfigurationsTrendSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (typeof this.date === "string") {
            this.date = new Date(<string><any>this.date);
        }
    }

    /**
     * Date of the time period
     */
    date: Date;

    /**
     * Severity of the misconfiguration
     */
    severity: models.MisconfigurationSeverity;

    /**
     * Count of misconfigurations for the given date and severity
     */
    count: number;

}
